import { forwardRef, type Ref, type SVGProps } from "react";
const IconXSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M24.052 3.345h4.293l-9.38 10.721L30 28.655h-8.64l-6.768-8.848-7.743 8.848H2.553l10.033-11.467L2 3.345h8.86l6.117 8.088zm-1.507 22.74h2.379L9.567 5.78H7.014l15.53 20.305Z" /></svg>;
const ForwardRef = forwardRef(IconXSVG);
ForwardRef.displayName = "IconX";
export { ForwardRef as IconX };